import axios from "axios";
import config from "../../config";
import axiosInstance from "../../utils/axiosInstance";

const BASE_URL = `${config.url}/api/banners`;

const BannerManager = {
  async getAllBanners() {
    const { data } = await axiosInstance.get("/banners");
    return data.responseData;
  },

  async getBannerById(id) {
    const { data } = await axiosInstance.get(`/banners/${id}`);
    return data.responseData;
  },

  async addBanner(banner, bannerImageFile) {
    const formData = new FormData();
    formData.append("bannerDetails", JSON.stringify(banner));
    if (bannerImageFile) {
      formData.append("bannerImage", bannerImageFile);
    }
    const { data } = await axiosInstance.post(
      `/banners/create`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return data.responseData;
  },

  async updateBanner(id, banner, bannerImageFile) {
    const formData = new FormData();
    formData.append("bannerDetails", JSON.stringify(banner));
    if (bannerImageFile) {
      formData.append("bannerImage", bannerImageFile);
    }
    const { data } = await axiosInstance.put(
      `/banners/${id}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return data.responseData;
  },

  async deleteBanner(id) {
    const { data } = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return data.responseCode === 200;
  },

  async uploadBannerImage(id, file, oldImagePath) {
    const formData = new FormData();
    formData.append("file", file);
    if (oldImagePath) formData.append("oldImagePath", oldImagePath);
    const { data } = await axiosInstance.post(
      `banners/${id}/upload-image`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return data.responseData;
  },
};

export default BannerManager;
